import { CLUSTER_SORTING_TYPES } from '../constants/sorting-types'
import { getQueryParam } from './parseURL.helper'
import { SORT_PARAM } from '../constants/query-params'
import { isEqual } from 'lodash'

export const sortClusters = (clusters, sortParam = getQueryParam(SORT_PARAM)) => {
    clusters = clusters.filter(cluster => cluster !== undefined && cluster !== null)

    switch (sortParam) {
        case CLUSTER_SORTING_TYPES.A_Z.value:
            clusters.sort((a, b) => a.cluster_name.localeCompare(b.cluster_name))
            break

        case CLUSTER_SORTING_TYPES.Z_A.value:
            clusters.sort((a, b) => b.cluster_name.localeCompare(a.cluster_name))
            break

        case CLUSTER_SORTING_TYPES.SMALL_TO_LARGE.value:
            clusters.sort((a, b) => a.files.length - b.files.length)
            break

        case CLUSTER_SORTING_TYPES.LARGE_TO_SMALL.value:
            clusters.sort((a, b) => b.files.length - a.files.length)
            break

        case CLUSTER_SORTING_TYPES.GRADE_ASC.value:
            clusters.sort((a, b) => a.grade - b.grade)
            break

        case CLUSTER_SORTING_TYPES.GRADE_DESC.value:
            clusters.sort((a, b) => b.grade - a.grade)
            break
    }

    return clusters
}

export const groupFilesBySetOfPatterns = files => {
    const filesGroupedBySetOfPatterns = new Map()
    files.map(file => {
        const setOfPatterns = file.motifList.map(motif => motif.motif_id).sort((a, b) => a - b)

        let setOfPatternsIsAlreadyKnown
        for (const key of filesGroupedBySetOfPatterns.keys()) {
            if (isEqual(key, setOfPatterns)) {
                setOfPatternsIsAlreadyKnown = key
                break
            }
        }

        if (!setOfPatternsIsAlreadyKnown) {
            filesGroupedBySetOfPatterns.set(setOfPatterns, [file])
        } else {
            filesGroupedBySetOfPatterns.get(setOfPatternsIsAlreadyKnown).push(file)
        }
    })
    return filesGroupedBySetOfPatterns
}

export const sortClustersFiles = (clusters, notConfidentSubmissions) => {
    clusters.forEach(cluster => {
        const filesGroupedBySetOfPatterns = groupFilesBySetOfPatterns(cluster.files)

        const sortedClusterFiles = []
        for (const [, filesOfSetOfPatterns] of filesGroupedBySetOfPatterns) {
            filesOfSetOfPatterns.map(file => {
                if (notConfidentSubmissions && file.id in notConfidentSubmissions) {
                    sortedClusterFiles.unshift(file)
                } else {
                    sortedClusterFiles.push(file)
                }
            })
        }
        cluster.files = sortedClusterFiles
    })
    return clusters
}

export const findSubmissionIndex = (clusters, submissionIdToFind) => {
    const allFiles = clusters.map(cluster => cluster.files).flat()
    return allFiles.findIndex(file => file.id === submissionIdToFind)
}
